import * as $ from 'jquery';
$(".footer-button").popover({
    animation: true,
    html: true,
    sanitize: false,
    placement: 'top',
    content: '<div class="px-2 py-3">For technical support, or if you have questions or feedback, please email <a href="mailto:review@socialventures.com.au">review@socialventures.com.au</a></div>',
    container: ".footer-popover-container"
});
export default undefined;
